import React, { useRef, useState } from 'react';
import './Consulta.css';
// import axios from 'axios'; // Commented out - not currently used
import Spiral from '../../Components/Spiral/Spiral'
export default function Consulta() {
    const dataForm = useRef();
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);

    // Función para enviar mensaje por WhatsApp
    const sendWhatsAppMessage = (nombre, telefono, email, consulta) => {
        const phoneNumber = '5215536445094'; // Número de WhatsApp con código de país
        const message = `*Nueva Consulta - Zura Inmobiliaria*%0A%0A*Nombre:* ${nombre}%0A*Teléfono:* ${telefono}%0A*Email:* ${email}%0A*Consulta:* ${consulta}`;
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
        window.open(whatsappUrl, '_blank');
    };

    async function handleFormSubmit(e) {
        e.preventDefault();

        const formData = new FormData(e.target);
        const nombre = formData.get('name');
        const telefono = formData.get('telefono');
        const email = formData.get('email');
        const consulta = formData.get('question');

        try {
            setLoading(true);

            // Enviar mensaje por WhatsApp
            sendWhatsAppMessage(nombre, telefono, email, consulta);

            setTimeout(() => {
                setLoading(false);
                setSuccessMessage('¡Redirigiendo a WhatsApp!');
                setTimeout(() => {
                    setSuccessMessage(false);
                }, 2000)
                dataForm.current.reset();
            }, 1000)

        } catch (error) {
            setLoading(false);
            setErrorMessage('Error al procesar la solicitud');
            setTimeout(() => {
                setErrorMessage('');
            }, 3000);
        }
    }

    // Función para abrir WhatsApp directo sin formulario
    const handleWhatsAppDirect = (e) => {
        e.preventDefault();
        const phoneNumber = '5215536445094';
        const message = `Hola, me gustaría obtener más información sobre las propiedades disponibles.`;
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div>
            <form action="" className="Formulario" onSubmit={handleFormSubmit} ref={dataForm}>
                <label htmlFor="">Contactá al anunciante</label>

                <div className="deFlexInputs">
                    <input className="inputt" type="text" placeholder="Nombre" name="name" id="name" style={{ color: 'white' }} required />

                    <input className="inputt" type="number" placeholder="Teléfono" name="telefono" id="telefono" style={{ color: 'white' }} required />
                </div>
                <input className="inputt" type="email" placeholder="Email" name="email" id="email" style={{ color: 'white' }} required />
                <textarea placeholder="Consulta" name="question" id="question" style={{ color: 'white' }} required></textarea>
                {successMessage && <p className="success-message">{successMessage}</p>}
                {errorMessage && <p className="error-message">{errorMessage}</p>}
                <div className="submit">
                    {loading ? (
                        <div className='enviar'>
                            <Spiral />
                        </div>
                    ) : (
                        <input type="submit" value="Enviar por WhatsApp"></input>
                    )}
                </div>

                <button className='wpp-btn' onClick={handleWhatsAppDirect} type="button">
                    Contactar por WhatsApp Directo
                </button>
            </form>


        </div>
    );
}
